var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.372 13.916s-.85-1.557-1.357-2.48c-.408-.515-.52-1.205-.3-1.824.448-.824.684-1.747.687-2.685 0-3.412-3.057-6.177-6.827-6.177S.748 3.515.748 6.927c0 3.412 3.057 6.176 6.827 6.176 1.11.096 2.223-.155 3.184-.72 0 0 1.234.587 1.972.944.833.37 1.73.57 2.64.59z"
  })));
};
export default SvgChat;